import jjv from 'jjv'
import moment from 'moment'
import extract, {replace, sanitize} from '../core/extract'
import cache from '../core/cache'
import {anyRequired} from '../core/validate'
import {isSameDay} from '../core/datez'
import phonez, {phoneFormat} from '../core/phonez'
import i18n from './i18n'

export const XLSX_TICKET_SHEET_COLUMNS = [
    'ref', 'created', 'agency', 'addressStreet', 'addressZipCode', 'addressCity', 'addressFloor', 'addressUnit', 'addressEntrance', 'addressElevator', 'addressStaircase', 'addressBuilding', 'addressComplement',
    'callerName', 'callerPhone', 'callerEmail', 'request', 'callPurpose', 'assigneeName', 'assigneePhone', 'assigneeType',
    'serviceOrderRef', 'serviceOrderSendingDate', 'interventionScheduledStartDate', 'interventionScheduledEndDate', 'interventionDeadline', 'formalNoticeDate', 'formalNoticeDeadline',
    'missionFinished', 'freeComments', 'status', 'state'
]

export const PDF_REPORT_PAGES = ['agency', 'patrimony', 'provider']
export const PDF_EXPORT_PAGES = ['journal']

export const CLOSE_TICKET_CMD_TYPES = ['FixPermanently', 'FixPartially', 'PostponeFix', 'CloseTicketImpossibleRepair', 'CloseBeyondCallCenterScope', 'CancelTicket']
export const INTERVENTION_CMD_TYPES = ['AcceptIntervention', 'RefuseIntervention']
export const SUPPORT_USERS = ['Manager', 'Admin', 'Inspector', 'CareTaker', 'Administrator']

export const CALL_PURPOSES = {
    electrecityHeating: ['boiler', 'heater', 'electrecity', 'elecman', 'lamp'],
    plumbing: ['hotwater', 'plumber', 'tap', 'waterdrop', 'waterman', 'watertap'],
    vmcGaz: ['vent', 'smokevent', 'parkingvent', 'gasvent', 'aircon', 'gasman', 'gas', 'manogas', 'pipe', 'pressure'],
    dangerAlarm: ['extinctor', 'firealarm', 'firefighters', 'intrusionalarm', 'alarm', 'burglar', 'evacuate', 'explosion', 'flood', 'vandalism'],
    sanitation: ['litter', 'pump', 'bucket'],
    elevator: ['elevator'],
    access: ['barrier', 'closedlock', 'openlock', 'fence', 'door', 'window', 'rollerblind', 'keys', 'brokenglass'],
    parking: ['parking'],
    monitoring: ['terminal', 'monitoring', 'tv']
}

export const INCIDENT_TYPE_ITEM_ICONS = {
    accesGarage: 'parking',
    aggretion: 'vandalism',
    alarme: 'alarm',
    ampouleGrillee: 'lamp',
    ascenseur: 'elevator',
    autreGenerique: 'other',
    barriereLevante: 'barrier',
    blattesCafards: 'bugs',
    bornes: 'terminal',
    cabineNonPresente: 'elevator',
    cabinePresente: 'elevator',
    cassee: 'brokenglass',
    chaude: 'hotwater',
    chaudiere: 'boiler',
    chauffage: 'heater',
    circuit: 'pipe',
    clef: 'keys',
    climatisation: 'aircon',
    collectif: 'relocate',
    compteurGaz: 'manogas',
    conteneurPoubelle: 'litter',
    couverture: 'roof',
    cumulusChauffeBain: 'boiler',
    debitEau: 'tap',
    degradation: 'vandalism',
    demande: 'questionmark',
    desenfumage: 'smokevent',
    eau: 'waterdrop',
    eauChaudeSanitaire: 'hotwater',
    eauSale: 'bucket',
    effraction: 'openlock',
    electrecite: 'electrecity',
    electrique: 'electrecity',
    electrocution: 'electrecity',
    explosion: 'explosion',
    extracteur: 'vent',
    extracteurFumees: 'smokevent',
    FlagrantDelit: 'burglar',
    fuiteEau: 'waterdrop',
    fuiteGaz: 'gas',
    garage: 'parking',
    gardiennage: 'careTaker',
    gaz: 'gas',
    grave: 'warning',
    guepesFrelonsAbeilles: 'bugs',
    horsService: 'wrench',
    importante: 'warning',
    incendie: 'firefighters',
    incidentsGraves: 'warning',
    individuel: 'manager',
    individusSuspects: 'burglar',
    infiltration: 'waterdrop',
    informationDossier: 'questionmark',
    informationTravaux: 'questionmark',
    innondation: 'flood',
    insectes: 'bugs',
    institutionnel: 'police',
    interphone: 'intercom',
    intrusion: 'intrusionalarm',
    issue: 'door',
    localVideOrdure: 'litter',
    logeGardien: 'careTaker',
    maconnerie: 'masonry',
    mauvaisFonctionnement: 'fail',
    menuiserie: 'window',
    message: 'message',
    nettoyage: 'bucket',
    ouverture: 'openlock',
    panne: 'wrench',
    panneChaudiere: 'boiler',
    panneEclairage: 'lamp',
    panneElectricite: 'electrecity',
    panneGaz: 'gas',
    panneTotale: 'fail',
    panneTV: 'tv',
    parking: 'parking',
    parkingGarage: 'parking',
    parkingMecanique: 'parking',
    piscine: 'swimmingpool',
    pompeRelevage: 'pump',
    portailCoulissant: 'fence',
    porteAcces: 'door',
    porteAntiIntrusion: 'door',
    porteAscenseur: 'elevator',
    porteGarage: 'fence',
    portePrivative: 'door',
    pressionFaible: 'pressure',
    problemeExtincteur: 'extinctor',
    radiateur: 'heater',
    risque: 'warning',
    risqueGrave: 'warning',
    robinet: 'watertap',
    serrureHS: 'keys',
    signalement: 'marker',
    situationRisque: 'warning',
    soutienPersonnes: 'relocate',
    tags: 'vandalism',
    telesurveillance: 'monitoring',
    tNTHertzien: 'tv',
    urgent: 'warning',
    ventilationGaz: 'gasvent',
    videOrdure: 'litter',
    videoSurveillance: 'monitoring',
    vitreCassee: 'brokenglass',
    vmc: 'vent',
    voletRoulantStore: 'rollerblind'
}

export const CORRECT_TICKET_EVENT_NAMES = ['MessageAdded', 'CallReceived', 'CallEmittedTo']
export const EMIT_CALL_TO_ASSIGNEE_HINTS = ['assigneeInterventionTransfer', 'assigneeIncidentAggravation', 'assigneeRemindIntervention', 'assigneeOther']
export const EMIT_CALL_TO_CALLER_HINTS = ['callerIncidentAggravation', 'callerAcceptIntervention', 'callerComplementaryInformation', 'callerContactWithCompany', 'callerSatisfaction', 'callerOther']
export const RECEIVE_CALL_FROM_ASSIGNEE_HINTS = ['assigneeComplementaryInformation', 'assigneeInterventionAdditionalContactInformation', 'assigneeInterventionCancellation', 'assigneeInterventionAcceptation', 'assigneeImpossibleAccess', 'assigneeScheduleIntervention', 'assigneeOther']
export const RECEIVE_CALL_FROM_CALLER_HINTS = ['callerIncidentAggravation', 'callerProviderPassed', 'callerComplementaryInformation', 'callerIncidentAccess', 'callerOther']
export const OPEN_TICKET_LOCATION_HINTS = ['unknownArea', 'commomArea', 'privateAreaExtending', 'privateArea', 'otherArea']
export const OPEN_TICKET_SEVERITY_HINTS = ['unknownSeverity', 'urgentSeverity', 'notUrgentSeverityExtending', 'notUrgentSeverity']
export const FINISH_MISSION_HINTS = ['scheduleInterventionManager', 'interventionPostponed', 'scheduleInterventionSelf', 'interventionPaused', 'interventionImpossible', 'interventionInProgress', 'interventionResolved', 'otherInterventiom']

export function createValidator() {
    const validator = jjv()

    validator.addCheck('anyRequired', anyRequired)
    validator.addFormat('phone', phoneFormat)
    return validator
}

export class Ticket {
}

Ticket.schema = {
    type: 'object',
    properties: {
    }
}

Ticket.accurateStatus = (ticket) => {
    if (ticket && ticket.state) {
        switch(ticket.state.value) {
            case 'TicketArchived': return 'archived'
            case 'TicketCancelled': return 'canceled'
        }
    }
    return ticket && ticket.status || null
}

Ticket.findActiveStateJournalEvent = (ticket) => {
    if (ticket && ticket.state) {
        const stateDate = ticket.state.date
        const stateEvent = ticket.state.value

        return ticket.journal.find((event) => {
            return (stateEvent == event.eventName) && isSameDay(stateDate, event.date)
        })
    }
    return null
}

Ticket.findJournalEvent = (ticket, eventName) => {
    if (ticket && ticket.journal) {
        return ticket.journal.find((event) => {
            return (eventName == event.eventName)
        })
    }
    return null
}

Ticket.findJournalEvents = (ticket, eventName) => {
    const events = []

    if (ticket && ticket.journal) {
        ticket.journal.forEach((event) => {
            if (eventName == event.eventName) {
                events.push(event)
            }
        })
    }
    return events
}

Ticket.isRepairTimeCompliant = (ticket) => {
    if (ticket && ticket.assignee && ticket.assignee.repairTimelimit && ticket.stats.repairTime) {
        return ticket.stats.repairTime <= ticket.assignee.commitments.repairTimelimit.value
    }
    return true
}

Ticket.isInterventionTimeCompliant = (ticket) => {
    if (ticket && ticket.assignee && ticket.assignee.commitments.interventionTimelimit && ticket.stats.interventionTime) {
        return ticket.stats.interventionTime <= ticket.assignee.commitments.interventionTimelimit.value
    }
    return true
}

Ticket.extractJournalEvent = (target, event) => {
    const eventName = sanitize(event && event.eventName)

    if (target) {
        const eventData = event && event.data
        const targetEvent = target[eventName]

        switch(eventName) {
            case 'callEmittedTo':
                return targetEvent && targetEvent[sanitize(eventData.medium)] || eventName
            case 'callReceived':
                return targetEvent && targetEvent[sanitize(eventData.medium)] || eventName
            case 'assigneeIdentified':
                return targetEvent && targetEvent[sanitize(eventData.identificationType)] || eventName
            default:
                return targetEvent || eventName
        }
    }
    return eventName
}

Ticket.replaceJournalEvent = (value, event) => {
    if (value) {
        const eventName = sanitize(event && event.eventName)
        const eventData = event && event.data

        switch(eventName) {
            case 'interventionScheduled':
                return replace(value, {
                    ...eventData,
                    date: moment(eventData.scheduledStartDate).format(i18n.dateFormat.default),
                    startTime: moment(eventData.scheduledStartDate).format(i18n.timeFormat.default),
                    endTime: moment(eventData.scheduledEndDate).format(i18n.timeFormat.default)
                })
            case 'sendingServiceOrderReported':
                return replace(value, {
                    ...eventData,
                    sendingDate: moment(eventData.sendingDate).format(i18n.dateFormat.default)
                })
            case 'interventionDeadlineDefined':
            case 'formalNoticeForProviderReported':
                return replace(value, {
                    ...eventData,
                    deadline: moment(eventData.deadline).format(i18n.dateFormat.default)
                })
            case 'interventionRequested':
                return replace(value, {
                    ...eventData,
                    medium: extract(i18n.mediumTypezEnum, eventData.medium),
                    identifier: phonez(eventData.identifier).format()
                })
            case 'callEmittedTo':
            case 'callReceived':
                return replace(value, {
                    ...eventData,
                    identifier: phonez(eventData.identifier).format()
                })
            default:
                return replace(value, eventData)
        }
    }
    return value
}

export class Criteria {
}

Criteria.schema = {
    type: 'object',
    properties: {
        fullText: {type: 'string'},
        status: {type: 'string'},
        intervention: {type: 'boolean'},
        location: {type: 'array'},
        clientCompany: {type: 'array'},
        agency: {type: 'array'},
        patrimony: {type: 'array'},
        callPurpose: {type: 'array'},
        from: {type: 'date'},
        to: {type: 'date'}
    }
}

export class ExportXlsxTicketsOption {
}

ExportXlsxTicketsOption.schema = {
    type: 'object',
    properties: {
        ticketSheetColumns: {type: 'array'},
        ticketSheetAdditionalData: {type: ['boolean', 'null']}
    }
}

export class ExportPdfTicketsOption {
}

ExportPdfTicketsOption.schema = {
    type: 'object',
    properties: {
        pages: {type: 'array'}
    }
}

export class ReportPdfTicketsOption {
}

ReportPdfTicketsOption.schema = {
    type: 'object',
    properties: {
        pages: {type: 'array'},
        from: {type: ['date', 'null']},
        to: {type: ['date', 'null']}
    }
}

export class OpenTicketCmd {
}

OpenTicketCmd.schemaCache = cache()

OpenTicketCmd.schema = {
    type: 'object',
    properties: {
        acknowledgeInstruction: {
            type: ['boolean', 'null'],
            enum: [true, null]
        },
        company: {type: 'object'},
        locationRef: {
            oneOf: [{
                type: 'object',
                properties: {
                    patrimonyUid: {type: 'object'},
                    locationReferenceType: {
                        type: 'string',
                        enum: ['PatrimonyLocation']
                    }
                },
                required: ['patrimonyUid', 'locationReferenceType']
            }, {
                type: 'object',
                properties: {
                    agencyUid: {type: 'object'},
                    locationReferenceType: {
                        type: 'string',
                        enum: ['AgencyLocation']
                    }
                },
                required: ['agencyUid', 'locationReferenceType']
            }]
        },
        restrictedAccess: {
            type: 'boolean'
        },
        ticket: {
            type: 'object',
            properties: {
                callerz: {
                    oneOf:[{
                        type: 'object',
                        properties: {
                            namez: {
                                type: 'object',
                                properties: {
                                    firstName: {type: 'string'},
                                    lastName: {type: 'string'},
                                    company: {type: ['string', 'null']}
                                },
                                required: ['firstName', 'lastName']
                            },
                            status: {
                                type: ['string', 'null']
                            },
                            medium: {
                                oneOf: [{
                                    type: 'object',
                                    properties: {
                                        phone: {
                                            type: 'string',
                                            format: 'phone'
                                        }
                                    },
                                    required: ['phone']
                                }, {
                                    type: 'object',
                                    properties: {
                                        mail: {
                                            type: 'string',
                                            format: 'email'
                                        }
                                    },
                                    required: ['mail']
                                }, {
                                    type: 'object',
                                    properties: {
                                        fax: {
                                            type: 'string',
                                            format: 'phone'
                                        }
                                    },
                                    required: ['fax']
                                }]
                            },
                            comment: {type: ['string', 'null']},
                            callerType: {
                                type: 'string',
                                enum: ['HumanCaller']
                            }
                        },
                        required: ['namez', 'callerType']
                    }, {
                        type: 'object',
                        properties: {
                            callerType: {
                                type: 'string',
                                enum: ['ReferencedContactCaller']
                            }
                        },
                        required: ['callerType']
                    }]
                },
                contactToCallback: {
                    type: ['object', 'null'],
                    properties: {
                        namez: {type: 'string'},
                        medium: {
                            oneOf: [{
                                type: 'object',
                                properties: {
                                    phone: {
                                        type: 'string',
                                        format: 'phone'
                                    }
                                },
                                required: ['phone']
                            }, {
                                type: 'object',
                                properties: {
                                    mail: {
                                        type: 'string',
                                        format: 'email'
                                    }
                                },
                                required: ['mail']
                            }, {
                                type: 'object',
                                properties: {
                                    fax: {
                                        type: 'string',
                                        format: 'phone'
                                    }
                                },
                                required: ['fax']
                            }]
                        },
                        availability: {type: ['date', 'null']},
                        comment: {type: ['string', 'null']}
                    },
                    required: ['namez', 'medium']
                },
                address: {
                    type: 'object',
                    properties: {
                        number: {type: ['string', 'null']},
                        street: {type: 'string'},
                        zipCode: {type: 'string'},
                        city: {type: 'string'},
                        staircase: {type: ['string', 'null']},
                        floor: {type: ['string', 'null']},
                        digicode: {type: ['string', 'null']}
                    },
                    required: ['street', 'zipCode', 'city']
                },
                openingTicketPurpose: {type: 'object'},
                request: {type: 'string'},
                instructions: {type: ['string', 'null']},
            },
            required: ['callerz', 'address', 'openingTicketPurpose', 'request']
        }
    },
    required: ['company', 'locationRef', 'ticket']
}

OpenTicketCmd.selectSchema = (cmd) => {
    const locationReferenceType = cmd && cmd.locationRef && cmd.locationRef.locationReferenceType || 'PatrimonyLocation'
    const callerType = cmd && cmd.ticket && cmd.ticket.callerz && cmd.ticket.callerz.callerType || 'ReferencedContactCaller'

    return OpenTicketCmd.schemaCache([locationReferenceType, callerType], () => {
        const locationRefSchema = OpenTicketCmd.schema.properties.locationRef.oneOf.find((schema) => {
            return schema.properties.locationReferenceType.enum.indexOf(locationReferenceType) >= 0
        })

        const callerzSchema = OpenTicketCmd.schema.properties.ticket.properties.callerz.oneOf.find((schema) => {
            return schema.properties.callerType.enum.indexOf(callerType) >= 0
        })

        return {
            ...OpenTicketCmd.schema,
            properties: {
                ...OpenTicketCmd.schema.properties,
                locationRef: locationRefSchema,
                ticket: {
                    ...OpenTicketCmd.schema.properties.ticket,
                    properties: {
                        ...OpenTicketCmd.schema.properties.ticket.properties,
                        callerz: callerzSchema
                    }
                }
            }
        }
    })
}

export class IdentifyAssigneeCmd {
}

IdentifyAssigneeCmd.schema = {
    type: 'object',
    properties: {
        assignee: {type: 'object'},
        comment: {type: ['string', 'null']},
        instructions: {type: ['string', 'null']}
    },
    required: ['assignee']
}

export class ReportSendingServiceOrderCmd {
}

ReportSendingServiceOrderCmd.schema = {
    type: 'object',
    properties: {
        ref: {type: 'string'},
        sendingDate: {type: 'date'}
    },
    required: ['ref', 'sendingDate']
}

export class DefineInterventionDeadlineCmd {
}

DefineInterventionDeadlineCmd.schema = {
    type: 'object',
    properties: {
        deadline: {type: 'date'}
    },
    required: ['deadline']
}

export class ReportFormalNoticeForProviderCmd {
}

ReportFormalNoticeForProviderCmd.schema = {
    type: 'object',
    properties: {
        deadline: {type: 'date'}
    },
    required: ['deadline']
}

export class ScheduleInterventionCmd {
}

ScheduleInterventionCmd.schema = {
    type: 'object',
    properties: {
        startDate: {type: 'date'},
        endDate: {type: 'date'}
    },
    required: ['startDate', 'endDate']
}

export class StartInterventionCmd {
}

StartInterventionCmd.schema = {
    type: 'object',
    properties: {
        startedDate: {type: 'date'}
    },
    required: ['startedDate']
}

export class FinishInterventionCmd {
}

FinishInterventionCmd.schema = {
    type: 'object',
    properties: {
        finishedDate: {type: 'date'}
    },
    required: ['finishedDate']
}

export class AddMessageCmd {
}

AddMessageCmd.schema = {
    type: 'object',
    properties: {
        message: {type: 'string'}
    },
    required: ['message']
}

export class CloseTicketCmd {
}

CloseTicketCmd.schema = {
    oneOf: [{
        type: 'object',
        properties: {
            report: {type: ['string', 'null']},
            commandType: {
                type: 'string',
                enum: ['FixPermanently', 'FixPartially', 'PostponeFix', 'CloseTicketImpossibleRepair']
            }
        },
        required: ['commandType']
    }, {
        type: 'object',
        properties: {
            comment: {type: ['string', 'null']},
            commandType: {
                type: 'string',
                enum: ['CancelTicket', 'CloseBeyondCallCenterScope']
            }
        },
        required: ['commandType']
    }]
}

CloseTicketCmd.selectSchema = (cmd) => {
    const commandType = cmd && cmd.commandType || CLOSE_TICKET_CMD_TYPES[0]

    return CloseTicketCmd.schema.oneOf.find((schema) => {
        return schema.properties.commandType.enum.indexOf(commandType) >= 0
    })
}

export class CorrectTicketInformationsCmd {
}

CorrectTicketInformationsCmd.schema = {
    type: 'object',
    properties: {
        fieldsToCorrect: {
            type: 'object',
            properties: {
                request: {type: ['string', 'null']},
                instructions: {type: ['string', 'null']},
                closingReport: {type: ['string', 'null']}
            },
            anyRequired: ['request', 'instructions', 'closingReport']
        }
    },
    required: ['fieldsToCorrect']
}

export class CorrectTicketEventInformationsCmd {
}

CorrectTicketEventInformationsCmd.schema = {
    type: 'object',
    properties: {
        text: {type: 'string'}
    },
    required: ['text']
}

export class ReceiveCallCmd {
}

ReceiveCallCmd.schema = {
    type: 'object',
    properties: {
        callerz: {type: 'string'},
        callPurpose: {type: 'string'},
        medium: {
            oneOf: [{
                type: 'object',
                properties: {
                    phone: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                required: ['phone']
            }, {
                type: 'object',
                properties: {
                    mail: {
                        type: 'string',
                        format: 'email'
                    }
                },
                required: ['mail']
            }, {
                type: 'object',
                properties: {
                    fax: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                required: ['fax']
            }]
        },
        comment: {type: ['string', 'null']}
    },
    required: ['callerz', 'callPurpose', 'medium']
}

export class EmitCallToCmd {
}

EmitCallToCmd.schemaCache = cache()

EmitCallToCmd.schema = {
    type: 'object',
    properties: {
        recipient: {
            oneOf: [{
                type: 'object',
                properties: {
                    namez: {
                        oneOf: [{
                            type: 'object',
                            properties: {
                                firstName: {type: 'string'},
                                lastName: {type: 'string'},
                                gender: {type: ['string', 'null']},
                                nameType: {
                                    type: 'string',
                                    enum: ['CivilName']
                                }
                            },
                            required: ['firstName', 'lastName', 'nameType']
                        }, {
                            type: 'object',
                            properties: {
                                value: {type: 'string'},
                                nameType: {
                                    type: 'string',
                                    enum: ['PoorName']
                                }
                            },
                            required: ['value', 'nameType']
                        }]
                    },
                    personaType: {
                        type: 'string',
                        enum: ['UnClassifiedPersona']
                    }
                },
                required: ['namez', 'personaType']
            }, {
                type: 'object',
                properties: {
                    provider: {type: 'object'},
                    personaType: {
                        type: 'string',
                        enum: ['ProviderPersona']
                    }
                },
                required: ['provider', 'personaType']
            }]
        },
        medium: {
            oneOf: [{
                type: 'object',
                properties: {
                    phone: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                required: ['phone']
            }, {
                type: 'object',
                properties: {
                    mail: {
                        type: 'string',
                        format: 'email'
                    }
                },
                required: ['mail']
            }, {
                type: 'object',
                properties: {
                    fax: {
                        type: 'string',
                        format: 'phone'
                    }
                },
                required: ['fax']
            }]
        },
        comment: {type: ['string', 'null']}
    },
    required: ['medium', 'recipient']
}

EmitCallToCmd.selectSchema = (cmd) => {
    const personaType = cmd && cmd.recipient && cmd.recipient.personaType || 'UnClassifiedPersona'
    const nameType = cmd && cmd.recipient && cmd.recipient.namez && cmd.recipient.namez.nameType || 'CivilName'

    return EmitCallToCmd.schemaCache([personaType, nameType/*, interventionAcceptedType*/], () => {
        var recipientSchema = EmitCallToCmd.schema.properties.recipient.oneOf.find((schema) => {
            return schema.properties.personaType.enum.indexOf(personaType) >= 0
        })

        if (personaType == 'UnClassifiedPersona') {
            const namezSchema = recipientSchema.properties.namez.oneOf.find((schema) => {
                return schema.properties.nameType.enum.indexOf(nameType) >= 0
            })

            recipientSchema = {
                ...recipientSchema,
                properties: {
                    ...recipientSchema.properties,
                    namez: namezSchema
                }
            }
        }

        return {
            ...EmitCallToCmd.schema,
            properties: {
                ...EmitCallToCmd.schema.properties,
                recipient: recipientSchema
            }
        }
    })
}

export class FinishMissionCmd {
}

FinishMissionCmd.schema = {
    type: 'object',
    properties: {
        comment: {type: ['string', 'null']}
    }
}

export function mediumToContactMedium(medium) {
    if (medium && medium.mediumType) {
        return {
            phone: medium.mediumType == 'PHONE' && phonez(medium.identifier).toE164() || undefined,
            mail: medium.mediumType == 'MAIL' && medium.identifier || undefined,
            fax: medium.mediumType == 'FAX' && phonez(medium.identifier).toE164() || undefined,
            contactMediumType: (medium.mediumType == 'PHONE' && 'Phone') || (medium.mediumType == 'MAIL' && 'Mail') || (medium.mediumType == 'FAX' && 'Fax')
        }
    }
    if (medium && medium.contactInfoType) {
        return {
            phone: medium.phone,
            mail: medium.mail,
            fax: medium.fax,
            contactMediumType: medium.contactInfoType
        }
    }
    return medium
}

export function plainContactToContactMedium(type) {
    return (plain) => {
        return {
            phone: type == 'Phone' && phonez(plain).toE164() || undefined,
            mail: type == 'Mail' && plain || undefined,
            fax: type == 'Fax' && phonez(plain).toE164() || undefined,
            contactMediumType: type
        }
    }
}

export function nameToPlainName(name) {
    if (name && name.nameType == 'CivilName') return [name.firstName, name.lastName].filter((v) => v).join(' ') || null
    if (name && name.nameType == 'PoorName') return name.value
    if (typeof name == 'object') return name.value || [name.firstName, name.lastName].filter((v) => v).join(' ') || null
    return name
}



// WEBPACK FOOTER //
// ./lib/ticket/models.js